
// call this right after a successful payment
export const reportAdsConversion = (paymentData) => {
  const amount =
    typeof paymentData?.amountCents === "number"
      ? Math.round(paymentData.amountCents / 100)
      : 0;

  if (!amount) return;

  // If GA4/Ads gtag.js is present (not just GTM), fire directly:
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-972421321/zxCTCNLhjo8bEMnx188D",
      value: amount,
      currency: "AUD",
    });
    return;
  }

  // Otherwise, push to GTM's dataLayer and let a GTM tag handle it
  if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: "purchase_conversion",
      currency: "AUD",
    });
  }
}